<template>
  <div :class="$style.keyboardContainer">
    <div :class="$style.flexContainer">
      <v-btn v-for="value of symbolsBeforeBackspace"
             :key="value"
             :class="$style.symbolButton"
             :disabled="disabled"
             @click="addSymbol(value)">
        {{ value }}
      </v-btn>
      <v-btn :class="$style.symbolButton"
             :disabled="disabled"
             @click="removeSymbol">
        <i class="material-icons">backspace</i>
      </v-btn>
      <v-btn v-for="value of symbolsAfterBackspace"
             :key="value"
             :class="$style.symbolButton"
             :disabled="disabled"
             @click="addSymbol(value)">
        {{ value }}
      </v-btn>
    </div>
    <v-btn :class="$style.spaceButton"
           :disabled="disabled"
           @click="addSpace"
    />
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';

/**
 * Keyboard for text component.
 */
@Component({
  props: {
    value: {
      type:     String,
      required: false,
    },
    disabled: {
      type:    Boolean,
      default: false,
    },
  },
})
export default class Keyboard extends Vue {
  symbolsBeforeBackspace = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
    'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p',
    'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l' ];
  symbolsAfterBackspace =[ 'z', 'x', 'c', 'v', 'b', 'n', 'm' ];

  get typedText() {
    return this.value;
  }

  set typedText(value) {
    this.$emit('input', value);
  }

  addSymbol(value) {
    const lastSymbol = this.typedText[this.typedText.length - 1];

    if (this.value === '') {
      this.typedText = '';
    }

    if (!lastSymbol || lastSymbol === ' ') {
      this.typedText = this.typedText + value.toUpperCase();

      return;
    }

    this.typedText = this.typedText + value;
  }

  addSpace() {
    this.addSymbol(' ');
  }

  removeSymbol() {
    this.typedText = this.typedText.slice(0, this.typedText.length - 1);
  }
}
</script>

<style lang="scss" module>
@import "@/style/variables.scss";

.keyboardContainer {
  background-color: $black-slightly-transparent;
  padding: 1.5%;
  text-align: center;
}

.flexContainer {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  min-width: 280px;
}

.symbolButton {
  min-width: 20px;
  width: 9%;
  margin: 0.5%;
  padding: 0 0 9%;
  position: relative;
  height: 0;
  font-size: 45px;
  font-weight: 600;
  text-transform: lowercase;
  div {
    background-color: $black-slightly-transparent;
    border: 6px solid $green2;
    color: $white;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    i {
      font-size: 45px;
    }
  }
}

.spaceButton {
  width: 60%;
  margin: 0.5% auto;
  padding: 0 0 9%;
  position: relative;
  height: 0;
  div {
    background-color: $black-slightly-transparent;
    border: 6px solid $green2;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}

@media (max-width: 500px) {
  .symbolButton,
  .spaceButton {
    font-size: 18px;
    div {
      border: 2px solid $green2;
      i {
        font-size: 18px;
      }
    }
  }
}

@media (min-width: 501px) and (max-width: 700px) {
  .symbolButton,
  .spaceButton {
    font-size: 25px;
    div {
      border: 3px solid $green2;
      i {
        font-size: 25px;
      }
    }
  }
}

@media (min-width: 701px) and (max-width: 1000px) {
  .symbolButton,
  .spaceButton {
    font-size: 30px;
    div {
      border: 4px solid $green2;
      i {
        font-size: 30px;
      }
    }
  }
}

@media (min-width: 1001px) and (max-width: 1200px) {
  .symbolButton,
  .spaceButton {
    font-size: 35px;
    div {
      border: 5px solid $green2;
      i {
        font-size: 35px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/apps/kiosk/components/Keyboard.vue